<template>
  <select class="form-control" v-bind="$attrs" :value="value"
  >
    <slot></slot>
  </select>
</template>

<script>
export default {
  name: "Select2",
  props: {
    config: {
      type: Object
    },
    options: {
      type: Array
    },
    value: {
      type: [String, Number, Object]
    },
    isInvalid: Boolean,
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el)
      .val(value)
      .trigger("change");
    },
    options: function (options) {
      // update options
      $(this.$el)
      .empty()
      .select2({data: options});
    },
    isInvalid: function (newValue, oldValue) {
      if (newValue) {
        $(this.$el).data('select2').$container.addClass('is-invalid')
      } else {
        $(this.$el).data('select2').$container.removeClass('is-invalid')
      }
    }
  },
  methods: {
    /**
     *
     * @param {number | string} id
     * @param {string} text
     * @param {boolean} selected
     * @param {boolean} disabled
     */
    addOption(id, text, selected = false, disabled = false) {
      let newOption = new Option(text, id, true, true);
      this.select2.append(newOption).trigger('change');
    },
  },
  data: function () {
    return {
      select2: {}
    }
  },
  mounted: function () {
    let vm = this;
    let config = Object.assign({
      theme: 'bootstrap4',
      allowClear: true,
      language: "vi",
      width: 'style',
      selectionCssClass: 'asdfasdf'
    }, this.config);
    this.select2 = $(this.$el).select2(config)
                              .val(this.value)
                              .trigger("change")
                              .on("change", function () {
                                vm.$emit("input", this.value ? this.value : null);
                              });

  },
  destroyed: function () {
    $(this.$el)
    .off()
    .select2("destroy");
  },
}
</script>

<style scoped>

</style>